import { createApp } from 'vue'
import FeedbackToolbar from './FeedbackToolbar'

const el = '.nyk-component--feedback-toolbar'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FeedbackToolbarDOM) => {
            const props = {
                itemId: FeedbackToolbarDOM.dataset.itemId ? +FeedbackToolbarDOM.dataset.itemId : null,
                labels: FeedbackToolbarDOM.dataset.labels ? JSON.parse(FeedbackToolbarDOM.dataset.labels) : null,
            }
            const component = createApp(FeedbackToolbar, props).use(Store)
            component.mount(FeedbackToolbarDOM)
        })
    }
}